import { partirCloze, type TipoItem } from "@noesis/shared";

/**
 * Os nomes que a tela mostra para o que o banco guarda com nome interno
 * (handoff de UI/UX, ADR 039): `multipla`, `certo_errado`, `cartao` e o
 * marcador de lacuna `{{1}}` nunca aparecem para quem estuda.
 */
export const NOME_DO_TIPO: Record<TipoItem, string> = {
  multipla: "Múltipla",
  certo_errado: "Certo/Errado",
  cartao: "Cartão",
  cloze: "Lacunas",
};

/** O traço que ocupa o lugar de uma lacuna em texto corrido. */
export const TRACO_DA_LACUNA = "__________";

/** O enunciado como texto de lista: cada `{{id}}` vira o traço da lacuna. */
export function enunciadoLegivel(enunciado: string): string {
  return partirCloze(enunciado)
    .map((p) => (p.tipo === "texto" ? p.valor : TRACO_DA_LACUNA))
    .join("");
}
